import React from 'react'
import { tokenizePathUrl } from '../../../../../shared/lib/helpers/TokenizePathUrl'

// Renderers for path-based tracking links, shared between the create/review flow
// (CreateAffiliateRule) and the saved-rule card (ProjectAffiliateRule).

// Highlights the target fragment in purple and (when `collapse`) replaces every
// other fragment with an ellipsis —
// e.g. https://brand.com/awin/af123#sub456 for `af123` → https://brand.com/.../af123#...
export const renderPathBasedUrl = (url: string, value: string, collapse: boolean) => {
  const parsed = tokenizePathUrl(url)
  if (!parsed) return url

  let highlighted = false

  return (
    <>
      {parsed.origin}
      {parsed.tokens.map((token, index) => {
        if (index % 2 === 1) {
          return <React.Fragment key={index}>{token}</React.Fragment>
        }

        if (!token) {
          return null
        }

        if (token === value && !highlighted) {
          highlighted = true
          return (
            <span key={index} className='text-default'>
              {token}
            </span>
          )
        }

        return <React.Fragment key={index}>{collapse ? '...' : token}</React.Fragment>
      })}
    </>
  )
}

// Replaces each fragment that has a role with the role name (purple) and every
// fragment without a role with an ellipsis —
// e.g. awin=Affiliate, af123=none, sub456=Network → https://brand.com/affiliate/...#network
export const renderPathBasedRoles = (
  url: string,
  getRole: (segment: string) => string | undefined,
) => {
  const parsed = tokenizePathUrl(url)
  if (!parsed) return url

  return (
    <>
      {parsed.origin}
      {parsed.tokens.map((token, index) => {
        if (index % 2 === 1) {
          return <React.Fragment key={index}>{token}</React.Fragment>
        }

        if (!token) {
          return null
        }

        const role = getRole(token)

        return role ? (
          <span key={index} className='text-default'>
            {role}
          </span>
        ) : (
          <React.Fragment key={index}>...</React.Fragment>
        )
      })}
    </>
  )
}
